export default "__VITE_ASSET__CaC31zCA__"